import { CreateOrEditTradingHaltProps } from "./create-or-edit-trading-halt.types";
import { CreateOrEditTradingHaltView } from "./create-or-edit-trading-halt-view";
import { useCreateOrEditTradingHalt } from "./use-create-or-edit-trading-halt";

export const CreateOrEditTradingHalt: React.FC<CreateOrEditTradingHaltProps> = (props) => {
  const logic = useCreateOrEditTradingHalt(props);
  return <CreateOrEditTradingHaltView {...logic} />;
};
